import React, { useEffect, useState } from 'react';
import { Col, FormFeedback, FormGroup, Input, InputGroupAddon, Label, Row } from 'reactstrap';
import { useSelector } from 'react-redux';

import useDebounce from './useDebounce';
import './ResetPassword.css';
import utils from '../../lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const checkboxes = ['auto', 'loginFirst', 'email'];

const ResetPassword = ({ formValues }) => {
  const userInfo = useSelector(state => state.UIState.users.updateUser);

  const [resetForm, setResetForm] = useState({
    password: '',
    confirmPassword: '',
    auto: true,
    email: true,
    loginFirst: true,
    pass: false,
  });
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const debounceValues = useDebounce(resetForm, 300);

  const onFieldChange = current => {
    const { name, value, checked } = current.target;
    if (checkboxes.some(checkbox => checkbox === name)) {
      setResetForm({ ...resetForm, [name]: checked });
    } else {
      setResetForm({ ...resetForm, [name]: value.trim() });
    }
  };

  useEffect(() => {
    formValues(debounceValues);
  }, [debounceValues]);

  return (
    <div>
      <FormGroup className="ml-4 mb-1">
        <Label check>
          <Input type="checkbox" name="auto" checked={resetForm.auto} onChange={onFieldChange} />
          Generate password automatically
        </Label>
      </FormGroup>
      <FormGroup className="ml-4 mb-1">
        <Label check>
          <Input
            type="checkbox"
            name="loginFirst"
            checked={resetForm.loginFirst}
            onChange={onFieldChange}
          />
          Require this user to change their password when they first login
        </Label>
      </FormGroup>
      <FormGroup className="ml-4 mb-1">
        <Label check>
          <Input type="checkbox" name="email" checked={resetForm.email} onChange={onFieldChange} />
          Email the sign-in info to me
        </Label>
      </FormGroup>
      {resetForm.auto ? null : (
        <>
          <FormGroup row>
            <Label sm={4}>New Password:</Label>
            <Col sm={9}>
              <Input
                type={showPass ? 'text' : 'password'}
                name="password"
                value={resetForm.password}
                onChange={onFieldChange}
                autoComplete="new-password"
                required
                minLength="8"
                placeholder="Enter new password"
                invalid={!utils.validatePassword(resetForm.password, userInfo.email)}
                valid={utils.validatePassword(resetForm.password, userInfo.email)}
              />
              <InputGroupAddon
                addonType="append"
                className="reset-password"
                onClick={() => setShowPass(!showPass)}
              >
                <FontAwesomeIcon icon={!showPass ? 'eye-slash' : 'eye'} size="lg" color="#8998ac" />
              </InputGroupAddon>
              <FormFeedback>
                Password must contain minimum 8 characters, at least one uppercase letter, one
                lowercase letter, one number and one special character
              </FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={6}>Repeat New Password:</Label>
            <Col sm={12}>
              <Row>
                <Col sm={9}>
                  <Input
                    type={showConfirmPass ? 'text' : 'password'}
                    name="confirmPassword"
                    value={resetForm.confirmPassword}
                    onChange={onFieldChange}
                    autoComplete="new-password"
                    required
                    minLength="8"
                    placeholder="Enter new password"
                    invalid={resetForm.password !== resetForm.confirmPassword}
                    valid={
                      resetForm.confirmPassword.length > 0 &&
                      resetForm.password === resetForm.confirmPassword
                    }
                  />
                  <InputGroupAddon
                    addonType="append"
                    className="reset-password"
                    onClick={() => setShowConfirmPass(!showConfirmPass)}
                  >
                    <FontAwesomeIcon
                      icon={!showConfirmPass ? 'eye-slash' : 'eye'}
                      size="lg"
                      color="#8998ac"
                    />
                    <FormFeedback>Repeat password should be same as new password.</FormFeedback>
                  </InputGroupAddon>
                </Col>
              </Row>
            </Col>
          </FormGroup>
        </>
      )}
    </div>
  );
};

export default ResetPassword;
